import Icon from './Icon';

const Remove = (props) => (
  <Icon
    {...props}
    path="M42.5 37.5h20.833c0.663 0 1.299 0.263 1.768 0.732s0.732 1.105 0.732 1.768-0.263 1.299-0.732 1.768c-0.469 0.469-1.105 0.732-1.768 0.732h-46.667c-0.663 0-1.299-0.263-1.768-0.732s-0.732-1.105-0.732-1.768 0.263-1.299 0.732-1.768c0.469-0.469 1.105-0.732 1.768-0.732h25.833z"
  />
);

export default Remove;
